import React, {Component} from 'react';
import './CommunityAddNotice.css';
import {ChooseBackground, Dialog, ValidatingInput} from '../widgets/';
import {connect} from 'react-redux';
import actions from './notices.actions';
import {uiActions} from '../chrome';

class CommunityAddNotice extends Component {
	render() {
		if (!this.props.notice) return null;

		const {
			notice: {title, content, backgroundURL},
			community,
			changeTitle,
			changeContent,
			changeBackground,
			dropBackgroundFile,
			onSave,
			onCancel
		} = this.props;

		return (
			<Dialog
				submitOnEnter={false}
				onSave={onSave}
				onCancel={onCancel}
				disabled={{
					save: !title || !title.length || !content || !content.length
				}}
				title="Add community notice">
				<ul className="CommunityAddNotice">
					<li>
						<label>
							<h3>Title</h3>
							<ValidatingInput
								type="text"
								className="CommunityAddNotice-entry"
								placeholder="Enter a title for the notice"
								maxLength={256}
								onChange={changeTitle}
								value={title}
								isValid={!!(title && title.length)}
								invalidMessage="Required"
								invalidTitle="A title is required for adding a notice"
								validIcon=""
							/>
						</label>
					</li>
					<li>
						<label>
							<h3>Description</h3>
							<textarea
								spellCheck={true}
								className="CommunityAddNotice-entry"
								placeholder="Write the expanded content of the notice here."
								value={content}
								maxLength={4000}
								onChange={changeContent}
							/>
						</label>
					</li>
					<li>
						<label>
							<h3>Header image</h3>
						</label>
						<ChooseBackground
							onSelect={changeBackground}
							selected={backgroundURL}
							allowUpload={community.subscription}
							dropBackgroundFile={dropBackgroundFile}
							items={[
								'/img/abstract-1.jpg',
								'/img/abstract-2.jpg',
								'/img/abstract-3.jpg',
								'/img/abstract-4.jpg',
								'/img/abstract-5.jpg',
								'/img/abstract-6.jpg',
								'/img/abstract-7.jpg'
							]}
						/>
					</li>
				</ul>
			</Dialog>
		);
	}
}

export const ConnectedCommunityEditNotice = connect(
	({community, notices}) => ({
		notice: notices && notices.editing,
		community
	}),
	dispatch => ({
		changeTitle: e => dispatch(actions.noticesChangedEditing({title: e.target.value})),
		changeContent: e => dispatch(actions.noticesChangedEditing({content: e.target.value})),
		changeBackground: img => dispatch(actions.noticesChangedEditing({backgroundURL: img})),
		dropBackgroundFile: (acceptedFiles, uuid) =>
			acceptedFiles[0] &&
			dispatch(actions.noticesDropBackgroundImgEditing({image: acceptedFiles[0], uuid})),
		onSave: () => {
			dispatch(actions.persistExistingNotice());
			dispatch(uiActions.uiModal(null));
		},
		onCancel: () => {
			dispatch(actions.noticesEditedCancelled());
			dispatch(uiActions.uiModal(null));
		}
	})
)(CommunityAddNotice);

const ConnectedCommunityAddNotice = connect(
	({notices, community}) => ({
		notice: notices && notices.adding,
		community
	}),
	dispatch => ({
		changeTitle: e => dispatch(actions.noticesChangedAdding({title: e.target.value})),
		changeContent: e => dispatch(actions.noticesChangedAdding({content: e.target.value})),
		changeBackground: img => dispatch(actions.noticesChangedAdding({backgroundURL: img})),
		dropBackgroundFile: (acceptedFiles, uuid) =>
			acceptedFiles[0] &&
			dispatch(actions.noticesDropBackgroundImgAdding({image: acceptedFiles[0], uuid})),
		onSave: () => {
			dispatch(actions.persistNotice());
			dispatch(uiActions.uiModal(null));
		},
		onCancel: () => {
			dispatch(actions.noticesAddingCancelled());
			dispatch(uiActions.uiModal(null));
		}
	})
)(CommunityAddNotice);

export default ConnectedCommunityAddNotice;



// WEBPACK FOOTER //
// ./src/community/CommunityAddNotice.js